import type { AxiosRequestConfig } from "axios";
import { URL_REJECT_AFTER_LOGIN } from "./constant";

export const checkValidToken = (
  token: string,
  expiresAt: string | number
): boolean => {
  if (!token || !expiresAt) return false;
  return new Date(Number(expiresAt) * 1000) > new Date();
};

export const setUrlRejectAfterLogin = (url: string) => {
  if (url) {
    sessionStorage.setItem(URL_REJECT_AFTER_LOGIN, url);
  }
};

/**
 * Config axios cho các request xác thực bằng **SSO access token** (không phải
 * token nội bộ của từng phân hệ): `POST /users/info-by-username` và mọi
 * `POST .../generate-token` của account/G-Ticket/G-Process/G-Performance/report-GT.
 * Header truyền theo request để không đè `Authorization` mặc định (token nội bộ)
 * đã/sẽ gắn trên instance.
 */
export const withSsoAuthorization = (
  ssoAccessToken: string
): AxiosRequestConfig => ({
  headers: { Authorization: `Bearer ${ssoAccessToken}` }
});
